<template lang="pug">
component(:class="`wagtail-title-${value.header}`" :is="value.header") {{ value.text }}
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>